/* Young Hound — galerie, sélecteur poids/palier, CTA collant.
   Pas de dépendance. Progressive enhancement : sans JS le formulaire poste
   quand même la variante par défaut. */
(function () {
  'use strict';

  var root = document.querySelector('[data-yh-pdp]');
  if (!root) return;

  var form = root.querySelector('[data-yh-form]');
  var idField = root.querySelector('[data-yh-variant-id]');
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
  var weights = Array.prototype.slice.call(root.querySelectorAll('[data-weight]'));
  var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mode]'));
  var ctaPrice = root.querySelector('[data-cta-price]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var sticky = root.querySelector('[data-yh-sticky]');

  function readJSON(sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var VARIANTS = readJSON('[data-yh-variants]', {});
  var MONTHS = readJSON('[data-yh-months]', { w1: 2, w2: 1, w3: 0.66 });

  var state = {
    mode: 'onetime',
    weight: weights.length ? weights[0].dataset.weight : '',
    wkey: weights.length ? weights[0].dataset.wkey : 'w1',
    tier: null
  };

  // -------------------------------------------------------------- helpers
  function money(n) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    return '$' + v.toFixed(2);
  }

  // Durée de cure lisible. Arrondit au mois seulement quand on en est
  // proche, sinon exprime en jours — sinon 2 pots pour un grand chien
  // afficheraient "1 month" au lieu de 40 jours.
  function supplyLabel(jars, monthsPerJar) {
    var m = jars * monthsPerJar;
    var nearest = Math.round(m);
    if (nearest >= 1 && Math.abs(m - nearest) <= 0.1) {
      return nearest + (nearest > 1 ? ' Months' : ' Month') + ' Supply';
    }
    return Math.round(m * 30) + ' Days Supply';
  }

  function activePrice(tier) {
    var raw = state.mode === 'subscribe' && tier.dataset.sub
      ? tier.dataset.sub
      : tier.dataset.price;
    return parseFloat(raw);
  }

  // ------------------------------------------------------------- galerie
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

  function showSlide(i) {
    slides.forEach(function (s) {
      if (s.dataset.slide === String(i)) s.setAttribute('data-active', '');
      else s.removeAttribute('data-active');
    });
    thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t.dataset.thumb === String(i) ? 'true' : 'false');
    });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showSlide(t.dataset.thumb); });
  });

  // ------------------------------------------------------- rendu des prix
  function render() {
    var monthsPerJar = Number(MONTHS[state.wkey]);
    if (!isFinite(monthsPerJar) || monthsPerJar <= 0) monthsPerJar = 1;

    tiers.forEach(function (tier) {
      var jars = parseInt(tier.dataset.jars, 10) || 1;
      var price = activePrice(tier);
      var compare = parseFloat(tier.dataset.compare);

      var supply = tier.querySelector('[data-supply]');
      if (supply) supply.textContent = supplyLabel(jars, monthsPerJar);

      var now = tier.querySelector('[data-now]');
      if (now) now.textContent = money(price);

      // Prix par jour, sur la durée réelle de la cure pour ce poids.
      var days = jars * monthsPerJar * 30;
      var perday = tier.querySelector('[data-perday]');
      if (perday && days > 0) {
        perday.textContent = money(price / days).replace('$', '$') + ' / day';
      }

      var save = tier.querySelector('[data-save]');
      if (save) {
        save.textContent = isFinite(compare) && compare > price
          ? 'Save ' + money(compare - price)
          : '';
      }
    });

    var selected = state.tier || tiers[0];
    if (!selected) return;

    // Variante = palier + poids. Le prix ne dépend que du palier, mais
    // l'id de variante dépend des deux.
    var key = selected.dataset.package + '|' + state.weight;
    var v = VARIANTS[key];
    if (v && idField) idField.value = v.id;

    var atc = root.querySelector('[data-yh-atc]');
    if (atc) {
      var unavailable = v && v.available === false;
      atc.disabled = !!unavailable;
    }

    var label = money(activePrice(selected));
    if (ctaPrice) ctaPrice.textContent = label + ' · Try Risk Free';
    if (stickyPrice) stickyPrice.textContent = label;
  }

  // ------------------------------------------------------------ écouteurs
  weights.forEach(function (btn) {
    btn.addEventListener('click', function () {
      weights.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      state.weight = btn.dataset.weight;
      state.wkey = btn.dataset.wkey;
      render();
    });
  });

  tiers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tiers.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      state.tier = btn;
      render();
    });
    if (btn.getAttribute('aria-pressed') === 'true') state.tier = btn;
  });

  modeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      state.mode = btn.dataset.mode;
      render();
    });
  });

  // ------------------------------------------------------- CTA collant
  if (sticky && form) {
    var stickyCta = sticky.querySelector('[data-yh-sticky-cta]');
    if (stickyCta) {
      stickyCta.addEventListener('click', function () { form.requestSubmit
        ? form.requestSubmit()
        : form.submit(); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            sticky.removeAttribute('data-shown');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.setAttribute('data-shown', '');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { rootMargin: '-120px 0px 0px 0px' });
      io.observe(form);
    }
  }

  render();
})();
